import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-location';

import pageCatalog from 'pages/pageCatalog';
import './styles.css';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const gameHowToPlay = require('common/assets/magicMovie/game-howtoplay-01.png');

export const MagicMovieHowToPlay: React.FC = () => {
  const { t } = useTranslation(['magicMovie']);
  const navigate = useNavigate();

  return (
    <div id="game" className="gameContainer howToPlay" data-test-id="magicMovieHowToPlayRoot">
      <div className="limitLine gameContentContainer">
        <div style={{ flex: 2 }}>
          <h1 style={{ marginBottom: '20px' }}>
            <div className="howToPlayImage" style={{ backgroundImage: 'url(' + gameHowToPlay + ')' }}></div>
            {t('howToPlay.title')}
          </h1>
          <ol
            className="blue"
            style={{
              marginBottom: '40px',
              marginTop: 0,
              listStyle: 'decimal',
            }}
          >
            <li style={{ marginBottom: '12px' }}>{t('howToPlay.assumeRole')}</li>
            <li style={{ marginBottom: '12px' }}>{t('howToPlay.interact')}</li>
            <li style={{ marginBottom: '12px' }}>{t('howToPlay.seeMovie')}</li>
          </ol>
          <button
            className="customButton"
            style={{
              maxWidth: '400px',
              fontSize: '24px',
              padding: '20px',
              borderRadius: '4px',
              background: 'orange',
              color: '#16191F',
            }}
            onClick={() => {
              navigate({ to: pageCatalog['MagicMovieUserName'].route });
            }}
            data-analytics-type="eventDetail"
            data-analytics="howserHowToPlayUserButton"
            data-test-id="magicMovieHowToPlayContinueButton"
          >
            {t('howToPlay.user')}
          </button>
        </div>
      </div>
    </div>
  );
};
